module.exports = __webpack_public_path__ + "img/5.c5c79616.jpg";